import useI18n from '@/shared/hooks/useI18n'
import { ProductionRouteStatus } from '@/hooks/useProductionRouteStatus'
import {
  CheckCircleIcon,
  CheckHalfDashedCircleIcon,
  DashedCircleIcon
} from '@/common/components/icons'
import RightArrow from '@/common/components/icons/RightArrow/RightArrow'
import cx from 'classnames'
import { Link } from 'react-router-dom'

export default function OperatorPeriodCard({
  periodId,
  status,
  label,
  installationId,
  productionRouteId
}: {
  periodId: string
  status: ProductionRouteStatus
  label: string
  installationId: string
  productionRouteId: string
}) {
  const { t } = useI18n()
  return (
    <Link
      to={`/dashboard/${installationId}/production-routes/${productionRouteId}/reports/${periodId}`}
    >
      <div
        className={cx(
          'bg-white min-w-72 transition-all duration-200 py-2 px-4 border flex items-center gap-3 shadow-drop hover:bg-blue-200 hover:border-blue-400 group/card'
        )}
      >
        {status === 'NOT_STARTED' && <DashedCircleIcon className="size-6 text-gray-400" />}

        {status === 'IN_PROGRESS' && (
          <CheckHalfDashedCircleIcon className="size-6 text-yellow-500" />
        )}

        {status === 'READY_FOR_FINALIZATION' && (
          <CheckHalfDashedCircleIcon className="size-6 text-green-500" />
        )}

        {status === 'REPORTED' && <CheckCircleIcon className="size-6 text-green-600" />}
        <div className="flex-1 flex flex-col gap-1">
          <h4 className="font-semibold">{label}</h4>
          <p className="text-sm text-text-secondary">
            {t(`dashboard:reporting.productionRouteStatus.${status}`)}
          </p>
        </div>
        <span>
          <RightArrow className="size-full" />
        </span>
      </div>
    </Link>
  )
}
